import {
    MotifButton,
    MotifCard,
    MotifCardBody,
    MotifCardHeader,
  } from '@ey-xd/motif-react';
  import React, { useCallback, useEffect } from 'react';
  import { useDispatch, useSelector } from 'react-redux';
  import { useNavigate } from 'react-router-dom';
  import AdminPageHeader from '../molecules/AdminPageHeader';
import ApprovalsListTable from '../molecules/ApprovalsListTable';
import AppAccordion from '../molecules/AppAccordion';
  
  const Approvals = () => {
    const [search, setSearch] = React.useState('');
    const { userDetails } = useSelector((state: any) => state.user);
    const { approvals } = useSelector((state: any) => state.admin);
  
    const navigate = useNavigate();
    const { users } = useSelector((state: any) => state.admin);
    const dispatch = useDispatch();
    const { access } = useSelector((state: any) => state.user);
  
    useEffect(() => {
      if(access.read) {
      dispatch(
        {
          type: 'GET_APPROVALS'
        },
        {}
      );
      // console.log("Hiii data = = ==  = ", approvals,"//////////", userDetails)
    }
    }, [access]);
  
    const triggerSearch = () => {
  
    };
    useEffect(() => {
      triggerSearch();
    }, [search]);
  
    useEffect(() => {
      if(userDetails?.isAdmin !== true) {
        navigate("/")
      }
    }, [userDetails]);
    
    if(userDetails?.isAdmin !== true) {
      return <></>
    }
  
    return (
      <div className="flex flex-col min-h-full m-3">
        <MotifCard className="min-h-[50vh] !bg-[transparent]">
          <MotifCardHeader className="!py-0" style={{ borderBottom: '1px solid #ffffff26' }}>
            <div className="flex gap-10 items-center !justify-between !w-full">
              <h4 className='!py-3 !font-bold'>Customized Query Approvals</h4>
            </div>
          </MotifCardHeader>
          <MotifCardBody className="!min-h-80">
            <AdminPageHeader
              // search={search}
              // setSearch={setSearch}
              title={"Below listed are the list of customized queries that need approval."}
            />
            {access.read === false && (
              <p className="text-center font-bold">Read access denied</p>
            )}
            <div className="flex flex-col gap-3">
              { approvals && approvals.map((itm, ind)=> (
                <AppAccordion title={`Workspace Id: ${itm.EngagementId}`}>
                    <ApprovalsListTable tableData={itm.questionnaireApprovals} />
                </AppAccordion>
              ))}

                {/* <AppAccordion title="Accordion 2">
                    <ApprovalsListTable tableData={[]} />
                </AppAccordion> */}
            </div>
            
          </MotifCardBody>
        </MotifCard>
      </div>
    );
  };
  
  export default Approvals;